export default __webpack_public_path__ + "static/media/ethereum.a85b6de0.png";